import script from "./IndexBar.vue?vue&type=script&setup=true&lang=js"
export * from "./IndexBar.vue?vue&type=script&setup=true&lang=js"

import "./IndexBar.vue?vue&type=style&index=0&id=59d54260&lang=css"

const __exports__ = script;

export default __exports__